import {ChangeDetectionStrategy, Component, NgModule, ViewEncapsulation} from '@angular/core';

/**
 * @ngModule InformationExprFlowerShieldSvgModule
 */
@Component({
  selector: 'svg[systemcodeInformationExprFlowerShield]',
  template: '<svg:path d="M22.15 21.62c2.43-4.77.3-12.26-8.12-12.26A31.1 31.1 0 0 0 5 10.8s2 13 11 13a13 13 0 0 0 3.16-.34" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></svg:path><svg:path d="M24 29.22v-1.91c0-7.75-12.64-13.66-12.64-13.66" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></svg:path><svg:path d="M40.79 23.4c4.53-2.64 1.49-8.19-3.62-7.45.63-2.28 2.25-5.3-.48-6.57-3.52-1.65-8.89.71-9.74 13.08" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></svg:path><svg:path d="M24 36.86v-7.35c0-7.17 9.37-11.34 9.37-11.34" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"></svg:path><svg:path d="M41.65 32.56A6.34 6.34 0 0 1 29 33a2.81 2.81 0 0 1 0-.41v-7l6.33-1.41 6.34 1.41z" fill="none" stroke-linecap="square" stroke-miterlimit="8" stroke-width="1.6"></svg:path><svg:path stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round" fill="none" d="M35.31 24.6v14"></svg:path><svg:path stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" fill="none" d="M41.63 31.6H29"></svg:path>',

  styles: [
    ':host { fill: currentColor; stroke: currentColor; }',
      ],

  host: {
    'viewBox': '0 0 48 48',
  },

  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationExprFlowerShieldSvgComponent {
}

@NgModule({
  declarations: [
    InformationExprFlowerShieldSvgComponent,
  ],
  exports: [
    InformationExprFlowerShieldSvgComponent,
  ],
})
export class InformationExprFlowerShieldSvgModule {}
